import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  CssBaseline,
  Snackbar,
  Typography,
  createSvgIcon,
  useTheme,
} from "@mui/material";

import { ReactComponent as IconFlow } from "../../assets/icons/IconEasyFlow.svg";
import { ReactComponent as IconReport } from "../../assets/icons/IconEasyReport.svg";
import { ReactComponent as IconMaps } from "../../assets/icons/IconEasyMaps.svg";
import { ReactComponent as IconLogo } from "../../assets/logosSvg/logoMW.svg";
import { ReactComponent as IconLog } from "../../assets/icons/IconEasyLog.svg";
import { Outlet, useLocation } from "react-router-dom";
import {
  Assignment,
  Home,
  PlaylistAdd,
  SupervisorAccountOutlined,
  ViewModule,
} from "@mui/icons-material";
//import LoadingPage from "../../componentes/loadingPage";
import TopBar from "../../componentes/topBar";
import SideBar from "../../componentes/sideBar";
import ModulesAlert from "../../componentes/modulesAlert";
import { ErrorBoundary } from "react-error-boundary";
import ErrorMessage from "../../componentes/easyMaps/errorMessage";
import api from "../../services/api";

const EasyFlowIcon = createSvgIcon(<IconFlow />);
const EasyReportIcon = createSvgIcon(<IconReport />);
const EasyMapsIcon = createSvgIcon(<IconMaps />);
const EasyLogIcon = createSvgIcon(<IconLog />);

function Layout(params) {
  const { colorMode, setColorMode, socket, socketCliente } = params;

  const [snackbar, setSnackbar] = useState(null);
  const [openRightBar, setOpenRightBar] = useState(true);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [titlePage, setTitlePage] = useState("");
  const [link, setLink] = useState("");
  const [settings, setSettings] = useState([]);
  const [pageConfig, setPageConfig] = useState(false); // armazena se a pina atual é a configuração
  const location = useLocation();
  const theme = useTheme();

  const isSuperAdmin =
    localStorage.getItem("1") &&
    JSON.parse(localStorage.getItem("1")).usuarioCliente.codigoPermissao ===
      "adm001";

  const clientLogo =
    colorMode === true
      ? `${
          window?.config?.REACT_APP_LOGO_MODE_DARK_URL ||
          window?.config?.REACT_APP_LOGO_URL ||
          ""
        }`
      : `${window?.config?.REACT_APP_LOGO_URL || ""}`;
  const isPartner = window?.config?.REACT_APP_IS_PARTNER === "true" || false;

  async function handleGetSettings() {
    try {
      const response = await api.get("/settings/findLimited");
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível carregar as configurações",
          severity: "error",
        });
      } else {
        if (response.data) {
          setSettings(response.data);
        }
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  useEffect(() => {
    handleGetSettings();
  }, []);

  const styles = {
    containerLayout: {
      display: "flex",
      width: "100%",
      height: "fit-content",
      flexDirection: "column",
    },
    containerBody: {
      display: "flex",
      width: "100%",
      height: "100%",
      minWidth: "350px",
    },
    containerOutlet: {
      flexGrow: 1,
      padding: 3,
      // paddingTop: 5,
      width: "100%",
      gap: 2,
      minWidth: "calc(100vw - 300px)",
    },
    titleAndLinkPage: {
      flexGrow: 1,
      fontWeight: 400,
      fontSize: "1.25rem",
      marginX: 1,
      mt: 1,
      mb: 2,
    },
  };
  const rightBarPages = [
    {
      itemId: "1",
      label: "Home",
      link: "/homeIn",
      hideTitle: true,
      icon: <Home />,
      group: "Navegação",
    },
    {
      itemId: "2",
      label: "Adição de Host",
      link: "/easyAdd",
      icon: <PlaylistAdd />,
      group: "Navegação",
    },
    ...(!isPartner
      ? [
          {
            itemId: "4",
            label: "EasyFlow",
            link: "/easyFlow",
            icon: <EasyFlowIcon />,
            group: "Navegação",
            openItem: true,
            nodes: [
              {
                itemId: "4.1",
                label: "Relatórios Flow",
                link: "/easyFlow/relatoriosFlow",
                produto: "EasyFlow",
              },
            ],
          },
        ]
      : []),

    {
      itemId: "6",
      label: "EasyReport",
      link: "/easyReportV2/relatorios",
      produto: "EasyReport",
      hideTitle: true,
      icon: <EasyReportIcon />,
      //  openInNewTab: true,
      group: "Navegação",
    },
    {
      itemId: "7",
      label: isPartner ? "Mapas" : "EasyMaps",
      link: "/easyMaps",
      produto: "EasyMaps",
      icon: <EasyMapsIcon />,
      //  openInNewTab: true,
      group: "Navegação",
    },
    {
      itemId: "8",
      label: isPartner ? "Log" : "EasyLog",
      hideTitle: true,
      link: "/easyLog",
      icon: <EasyLogIcon />,
      openItem: true,
      group: "Navegação",
      nodes: [
        {
          itemId: "8.1",
          label: "Histórico de Logs",
          link: "/easyLog/historico",
          produto: "EasyLog",
          hideTitle: true,
        },
        {
          itemId: "8.2",
          label: "Insights",
          link: "/easyLog/insights",
          produto: "EasyLog",
          hideTitle: true,
        },
      ],
    },
  ];
  const easyMapsOnly =
    window?.config?.REACT_APP_EASYMAPS_ONLY === "true" || false;

  const rightBarPagesConfig = [
    {
      itemId: "1",
      label: "Gestão de usuários",
      link: "/configuracoes/administracao",
      icon: <SupervisorAccountOutlined />,
      hideTitle: true,
      group: "Sistema",
    },
    ...(!easyMapsOnly
      ? [
          {
            itemId: "2",
            label: "EasyLogs",
            link: "/configuracoes/easyLogs",
            icon: <EasyLogIcon />,
            hideTitle: true,
            group: "Produtos",
          },
          {
            itemId: "3",
            label: "EasyReport",
            link: "/configuracoes/easyReport",
            icon: <EasyReportIcon />,
            hideTitle: true,
            group: "Produtos",
          },
          ...(isSuperAdmin
            ? [
                {
                  itemId: "4",
                  label: "Módulos",
                  link: "/configuracoes/modulos",
                  icon: <ViewModule />,
                  hideTitle: true,
                  group: "Sistema",
                },
              ]
            : []),
          // {
          //   itemId: "6",
          //   label: "EasyFlow",
          //   link: "/configuracoes/easyFlow/planilhas",
          //   icon: <EasyFlowIcon />,
          //   hideTitle: true,
          //   group: "Produtos",
          // },
        ]
      : []),
    ...(isSuperAdmin
      ? [
          {
            itemId: "5",
            label: "Auditoria",
            link: "/configuracoes/auditoria",
            icon: <Assignment />,
            hideTitle: true,
            group: "Sistema",
          },
        ]
      : []),
  ];

  useEffect(() => {
    setPageConfig(location.pathname.includes("/configuracoes"));
  }, [location.pathname]);

  return (
    <Box display={"flex"} sx={{ flexDirection: "column", height: "100%" }}>
      <ModulesAlert />
      <CssBaseline />

      <Box sx={styles.containerLayout}>
        <TopBar
          setOpenDrawer={setOpenDrawer}
          setOpenRightBar={setOpenRightBar}
          iconLogo={<IconLogo />}
          clientLogo={clientLogo}
          link={"/homeIn"}
          socket={socket}
          socketCliente={socketCliente}
          colorMode={colorMode}
          setColorMode={setColorMode}
          snackbar={snackbar}
          setSnackbar={setSnackbar}
          openRightBar={openRightBar}
        />{" "}
        <Box sx={styles.containerBody}>
          <SideBar
            items={pageConfig ? rightBarPagesConfig : rightBarPages}
            title="Navegação"
            openRightBar={openRightBar}
            setOpenRightBar={setOpenRightBar}
            openDrawer={openDrawer}
            setOpenDrawer={setOpenDrawer}
            iconLogo={<IconLogo />}
            clientLogo={clientLogo}
            titlePage={titlePage}
            setTitlePage={setTitlePage}
            link={link}
            setLink={setLink}
            settings={settings}
          />
          {/* <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}> */}
          <Box component="main" sx={styles.containerOutlet}>
            {/* <Link
              href={link}
              color="text.secondary"
              sx={styles.titleAndLinkPage}
            >
              {titlePage}
            </Link> */}
            <ErrorBoundary
              FallbackComponent={() => (
                <ErrorMessage
                  message={"Algo deu errado ao carregar o sistema"}
                />
              )}
            >
              {titlePage && (
                <Typography
                  color="text.primary"
                  variant="h5"
                  sx={styles.titleAndLinkPage}
                >
                  {titlePage}
                </Typography>
              )}
              <Outlet context={{ setTitlePage, socketCliente, settings }} />
            </ErrorBoundary>
          </Box>
        </Box>
        {/* </Box> */}
      </Box>
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </Box>
  );
}

export default Layout;
